import { useContextKeycloak } from "@/app/module/index";
import { useMemo } from "react";

export function useKeycloak() {
  const { jwtToken, authorize, fetchKeycloakLogout, fetchKeycloakLogin } =
    useContextKeycloak();

  return useMemo(
    () => ({
      token: jwtToken,
      authorize,
      logout: fetchKeycloakLogout,
      login: fetchKeycloakLogin,
    }),
    [jwtToken, authorize, fetchKeycloakLogout, fetchKeycloakLogin],
  );
}
